import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Skills = class Skills extends VuexModule {
    constructor() {
        super(...arguments);
        this.skills = [];
        this.cachedVersion = 0;
    }
    async fetchSkills() {
        const { data: skills, cachedVersion } = await fetchFromCache(this, 'skills', 'skills', 'skillsLU');
        return { skills, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['skills', 'cachedVersion'] })
], Skills.prototype, "fetchSkills", null);
Skills = __decorate([
    Module({ namespaced: true, name: 'skills' })
], Skills);
export default Skills;
